import React from "react";
import { Link } from "react-router";
import { ChartLine, SquareArrowOutUpRight } from "lucide-react";
import { projects } from "../constants/projectsInfo";
import "../styles/portfolio.css";

const Portfolio = () => {
	return (
		<div
			id="projects"
			className="project_container"
		>
			<h1 className="project_title">Projects</h1>
			<div className="project_items">
				{projects.map((proj, i) => (
					<div
						className="project_item"
						key={i}
					>
						<img
							src={proj.imgSrc}
							alt={proj.alt}
							width={400}
						/>
						<div className="project_info">
							<h2>{proj.name}</h2>
							<p>{proj.description}</p>
							{proj.technology.map((tech, i) => (
								<>
									<span key={i}>{tech}</span>
								</>
							))}
							<div className="preview_container">
								<p className="preview_link">
									<Link
										to={proj.link}
										target="_blank"
									>
										<SquareArrowOutUpRight size={14} />&nbsp; 
										View Live 
									</Link>
								</p>
								<p className="preview_link">
									{proj.analytics ? (
										<Link
											to={proj.analytics}
											target="_blank"
										>
											<ChartLine size={14}/> &nbsp;
											Page Analytics 
										</Link>
									) : null}
								</p>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default Portfolio;
